import React from 'react'
import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'

import { TextField } from '@mxenabled/mxui'
import { Cancel as HighlightOffIcon, Search as SearchIcon } from '@mxenabled/mx-icons'

import { useGlobalCopyStore } from '../../../common'

interface SearchBoxProps {
  onSearchValueChanged: (value: string) => void
  searchValue: string
}

const SearchBox: React.FC<SearchBoxProps> = ({ onSearchValueChanged, searchValue }) => {
  const { common: commonCopy, transactions: copy } = useGlobalCopyStore()

  const cancelButton = (
    <IconButton
      aria-label={copy.tags_cancel_search || 'Search'}
      onClick={() => onSearchValueChanged('')}
    >
      <HighlightOffIcon />
    </IconButton>
  )

  return (
    <Box className="mx-txn-tag-manager-search" px={24} py={16}>
      <TextField
        aria-label={commonCopy.search_aria}
        name="search"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearchValueChanged(e.target.value)}
        placeholder={commonCopy.search_placeholder}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="disabled" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end" sx={{ padding: 0 }}>
                {searchValue ? cancelButton : null}
              </InputAdornment>
            ),
          },
        }}
        // TODO: Theme needs to have the background color defaulted to paper for TextField
        sx={{ bgcolor: 'background.paper', width: '100%' }}
        value={searchValue}
      />
    </Box>
  )
}

export default observer(SearchBox)
